import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { without } from 'lodash';
import {
    Header, ShowMore, NoData, addIds, sortData, addSortFns,
} from 'rp-react-table';
import columnsFactory from './columns';
import NicksRow from './components/NickRow';

const tableClassName = 'ui-table ui-table_type1 ui-table_sortable';
const initialSortIdx = 2;
const defaultSortIdx = initialSortIdx;
const perPage = 50;

class Nicks extends PureComponent {
    constructor(props) {
        super(props);

        const { data: { nick: data = [] } } = props;

        const bindedColumns = columnsFactory(this.onIconClick);
        this.columns = addSortFns(bindedColumns, true);

        const tableData = sortData(
            addIds(data), this.columns, initialSortIdx, defaultSortIdx
        );

        this.state = {
            tableData,
            sortIdx: initialSortIdx,
            itemsShown: perPage,
            expandedRowIds: [],
            dataStorage: {},
        };
    }

    onIconClick = (horseUid) => {
        if (this.state.expandedRowIds.includes(horseUid)) {
            this.setState(({ expandedRowIds }) => ({
                expandedRowIds: without(expandedRowIds, horseUid),
            }));

            return;
        }

        this.setState(({ expandedRowIds }) => ({
            expandedRowIds: [...expandedRowIds, horseUid],
        }));

        if (this.state.dataStorage[horseUid]) { return; }

        axios.get(`horse/descendants/${this.props.params.id}/${horseUid}`)
            .then(({ data }) => {
                this.setState(({ dataStorage }) => ({
                    dataStorage: {
                        ...dataStorage,
                        [horseUid]: data.nickDescendants || [],
                    },
                }));
            })
            .catch(console.warn);
    }

    showMore = () => {
        this.setState(state => ({
            itemsShown: state.itemsShown + perPage,
        }));
    }

    sortTable = (idx) => {
        this.setState(({ tableData }) => ({
            tableData: sortData(tableData, this.columns, idx, defaultSortIdx),
            sortIdx: idx,
            expandedRowIds: [],
        }));
    }

    render() {
        const {
            tableData, sortIdx, itemsShown, expandedRowIds, dataStorage,
        } = this.state;

        return (
            <section className="hp-nicks">
                <table className={tableClassName}>
                    <Header
                        columns={this.columns}
                        sortIdx={sortIdx}
                        sortable={!!tableData.length}
                        sortTable={this.sortTable}
                        onHeaderCellClick={this.sortTable}
                    />
                    {!tableData.length &&
                        <tr className="ui-table__row">
                            <td colSpan="8">
                                <NoData text="No nicks for this sire in the Racing Post database" />
                            </td>
                        </tr>
                    }
                    {tableData.slice(0, itemsShown).map((rowData) => {
                        const expanded = expandedRowIds.includes(rowData.horseUid);

                        return (
                            <NicksRow
                                key={rowData.horseUid}
                                rowData={rowData}
                                columns={this.columns}
                                expanded={expanded}
                                data={expanded ? dataStorage[rowData.horseUid] : null}
                            />
                        );
                    })}
                </table>
                {itemsShown < tableData.length &&
                    <ShowMore onClick={this.showMore} />
                }
            </section>
        );
    }
}

Nicks.propTypes = {
    data: PropTypes.shape({
        nick: PropTypes.arrayOf(PropTypes.shape({
            horseUid: PropTypes.number.isRequired,
            styleName: PropTypes.string.isRequired,
            runs: PropTypes.number.isRequired,
            wins: PropTypes.number.isRequired,
            winsPercent: PropTypes.number.isRequired,
            runners: PropTypes.number.isRequired,
            winners: PropTypes.number.isRequired,
            winnersPercent: PropTypes.number.isRequired,
            totalMoney: PropTypes.number.isRequired,
            winPrizeMoney: PropTypes.number.isRequired,
            descendants: PropTypes.bool.isRequired,
        })),
    }).isRequired,
    params: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default Nicks;



// WEBPACK FOOTER //
// ./src/js/horse/nicks/Nicks.jsx